import script from "./ItemSkuAttrsHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemSkuAttrsHeader.vue?vue&type=script&setup=true&lang=ts"

import "./ItemSkuAttrsHeader.vue?vue&type=style&index=0&id=622eb366&lang=scss"

const __exports__ = script;

export default __exports__